import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { useStyles } from 'react-native-unistyles'

const SkeletonItem: FC = () => {
    const { styles } = useStyles(stylesheet)

    return <View style={styles.container} />
}

const stylesheet = StyleSheet.create({
    container: {
        backgroundColor: ColorEnum.VIOLET_100,
        borderRadius: 8,
        height: 48,
        minWidth: 100,
        maxWidth: '100%',
    },
})

export default SkeletonItem
